import React from 'react';

export const Mailbox = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 80 80" {...props}>
		<g fillRule="evenodd" stroke="none" strokeWidth="1">
			<path d="M20 6v11.398h4.042v56.455h32.552V17.398h4.042V6H20zm2.909 8.489h34.817V8.91H22.909v5.579zm4.043 46.843h26.733V17.398H26.952v43.934zm0 9.612h26.733v-6.702H26.952v6.702zm7.195-43.036h12.341v-2.91H34.147v2.91zm0 18.835h12.341V34.401H34.147v12.342zm2.91-2.91h6.522v-6.522h-6.522v6.522z" />
		</g>
	</svg>
);
